// REACT_APP_BIRMS_DIRECT turns the new payment card and BIRMS payments page on: 'true' for everyone, 'optin' (shared
// dev) only in a browser that opened a page with ?birmsDirect=1, until ?birmsDirect=0, so one tester doesn't change
// everyone's flow.
// No imports here: routes and navigation read this flag, and importing the service from them
// closes a cycle through @utils → router/routes that breaks the dev server.
const mode = process.env.REACT_APP_BIRMS_DIRECT

const optedIn = () => {
  try {
    const asked = new URLSearchParams(window.location.search).get('birmsDirect')
    if (asked === '1') localStorage.setItem('birmsDirect', '1')
    if (asked === '0') localStorage.removeItem('birmsDirect')
    return localStorage.getItem('birmsDirect') === '1'
  } catch {
    return false
  }
}

export const BIRMS_DIRECT = mode === 'true' || (mode === 'optin' && optedIn())
